<template>
  <section
    v-loading="loading"
    class="page-container">
    <div class="header flex-sb-center">
      <p class="title color-dark">{{formKycTitle}}</p>
      <font-awesome-icon
        icon="times"
        class="close pointer"
        @click="handleBack"
      ></font-awesome-icon>
    </div>
    <div class="content ">
      <div class="form-card flex-sb-center">
        <div class="form-left">
          <span
            class="upload-card">
            <el-image
              ref="imagePreview"
              :src="photoUrl"
              :preview-src-list="[photoUrl]"
              :preview-teleported="true"
            >
            </el-image>
          </span>
        </div>
        <div class="form-right">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <div
              v-for="(item,kcy_index) in formKycList"
              :key="kcy_index"
              class="form-item">
              <template v-if="![2].includes(ocr_data[item.id])">
                <span>{{item.id=='id_no'?(ocr_data['id_type']==1?'HKID':'Passport'):item.name}}</span>
                <el-form-item
                  :ref="item.id"
                  :rules="rules.input"
                  :prop="item.id">
                  <template v-if="item.type==1">
                    <v-select
                      v-model="formData.files[index].ocr[item.id]"
                      :list="item.option"></v-select>
                  </template>
                  <template v-else>
                    <v-input
                      v-model="formData.files[index].ocr[item.id]"
                      uppercase></v-input>
                  </template>
                </el-form-item>
              </template>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <div class="flex-sb-wrap footer">
      <div class="flex-1">
        <v-button
          gray
          @click="handleLast">Cancel</v-button>
      </div>
      <div class="flex-1">
        <el-steps
          :active="index"
          finish-status="success">
          <el-step
            v-for="(step,index) in fileList"
            :key="'step_'+index"
            @click.native="handleStep(index)"
          ></el-step>
        </el-steps>
      </div>
      <div class="flex-1 text-right">
        <v-button
          green
          @click="handleNext">Next</v-button>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'
import MixinSelectQuote from '@/mixins/select-quote'
import {mapActions} from 'vuex'
import {getOcrAsyncData, ocrFileDetail} from '@api/ocr'

export default {
  name: 'disc-upload',
  mixins: [MixinOptions, MixinRules,MixinFormat,MixinSelectQuote],
  data(){
    return{
      index:0,
      formData:{
        files:[]
      },
      pollStartTime: null,
      loading: false
    }
  },
  computed:{
    selectList(){
      return (name)=>{
        let obj = {
          isrd_title:this.titleOptions,
        }
        return obj[name]
      }
    },
    severType(){
      let {severType} = this.$route.params||{}
      return severType
    },
    fileList(){
      let {files=[]} = this.createQuoteForm||{}
      return files||[]
    },
    file_data(){
      let {files=[]} = this.createQuoteForm||{}
      return files[this.index]||{}
    },
    ocr_data(){
      let {ocr} = this.file_data||{}
      return ocr||{}
    },
    photoUrl() {
      let {file_detail} = this.file_data||{}
      let {url} =file_detail||{}
      return  url||''
    },
    formKycList(){
      let { ocr } = this.file_data || {}
      let arr = []
      if (!ocr) return []
      Object.keys(ocr).forEach(key => {
        const matchedItems = this.showKycForm.filter(item => item.id == key)
        arr = arr.concat(matchedItems)
      })
      return arr
    },
    formKycTitle(){
      let {type,location} = this.file_data||{}
      const rootOption = this.uploadTypeOptions.find((option) => option.id === type)
      if (!rootOption) return ''
      let subName = ''
      if (rootOption.location) {
        const subOption = rootOption.location.find((item) => item.id === location)
        if (subOption) {
          subName = subOption.name
        }
      }
      return subName ? `${rootOption.name}/${subName}` : rootOption.name

    }
  },
  watch:{
    createQuoteForm:{
      immediate:true,
      handler(val){
        let {files,ref_agency_id} = val||{}
        this.formData.files =files||[]
        this.formData.ref_agency_id = ref_agency_id
      }
    }
  },
  mounted() {
    let {ocr,async,async_id} = this.fileList[0]||{}
    if(!ocr&&async==false){
      this.handleNext()
    }
    if(async==true&&async_id){
      this.network().getOcrAsyncData({async_id},0)
    }
    this.$nextTick(()=>{
      this.$refs.imagePreview.clickHandler()
    })
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.pollTimer) {
      clearTimeout(this.pollTimer)
      this.pollTimer = null
    }
  },
  methods:{
    ...mapActions('quote',['setCreateQuoteForm']),
    handleStep(index) {
      setTimeout(()=>{
        this.$refs.form.clearValidate()
      },50)
      this.index = index
      let {ocr,async,async_id} = this.fileList[this.index]||{}
      if(!ocr&&async==false){
        this.handleNext()
      }
      if(async==true&&async_id){
        this.network().getOcrAsyncData({async_id},this.index)
      }
    },
    handleNext(){
      setTimeout(()=>{
        this.$refs.form.clearValidate()
      },50)
      if(this.index>=(this.fileList.length-1))
      {
        this.handleConfirm()
      }else
      {
        this.index += 1
        let {ocr,async,async_id} = this.fileList[this.index]||{}
        if(!ocr&&async==false){
          this.handleNext()
        }
        if(async==true&&async_id){
          this.network().getOcrAsyncData({async_id},this.index)
        }
      }
    },
    handleLast(){
      this.handleBack()
    },
    handleConfirm(){
      let{type,product_id,class_id,ref_agency_id} = this.createQuoteForm||{}
      let {files} = this.formData||{}
      let params ={
        source:ref_agency_id
      }
      this.setCreateQuoteForm({...this.createQuoteForm,files})
      if(type==1){
        this.$router.push(
          {
            path: `/create/sme/${this.severType}/tickets/${product_id}`,
            query:params
          }
        )
      }else {
        if(product_id==13){
          this.network().getQuoteAllNew({class_id: 22})
        }else {
          this.$router.push(
            {
              path: `/quoting/${this.severType}/underwriting`,
              query:params
            }
          )
        }
      }

    },
    handleBack(){
      this.$router.replace('/quoting/select/create')
    },
    network() {
      return {
        getOcrAsyncData: async (params, index) => {
          const POLL_INTERVAL = 2000 // 3秒轮询间隔
          this.loading = true
          const poll = async () => {
            try {
              const { data } = await getOcrAsyncData({
                ...params,
                hideMessage: true,
                hideLoading: true,
              })

              const { async, ocr = {} } = data || {}
              const files = [...this.formData.files]

              // 处理完成状态
              if (!async) {
                if (this.pollTimer) clearTimeout(this.pollTimer)
                this.loading = false
                files[index] = {
                  ...files[index],
                  async,
                  ...(ocr && { ocr }) // 如果有结果则添加ocr字段
                }
                this.setCreateQuoteForm({
                  ...this.createQuoteForm,
                  files
                })

                // 如果没有OCR结果则自动下一步
                if (!ocr) {
                  this.$nextTick(() => {
                    this.handleNext()
                  })
                }
                return
              }

              // 继续轮询
              this.pollTimer = setTimeout(poll, POLL_INTERVAL)

            } catch (error) {
              console.error('轮询错误:', error)
              this.loading = false
              if (error.status === 404) {
                // 任务不存在则跳过
                this.handleNext()
              } else {
                console.error('轮询错误:', error)
              }
            }
          }
          // 清除之前的轮询
          if (this.pollTimer) clearTimeout(this.pollTimer)
          poll() // 开始轮询
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container{

  margin: -20px;
  .header,.footer{
    padding: 20px;
  }
  .header{
    background: $gray;
  }
  .content{

    padding:0 20px;
    .form-left,
    .form-right {
      width: calc(50% - 10px);
      height: calc( 100vh - 136px);
    }
    .form-left {
      display: flex;
      background: rgb(88, 96, 105);
      flex-direction: column;
      z-index: 1;
      position: relative;
      overflow: hidden;
    }
    .form-right{
    }
  }

  .upload-card {
    z-index: 0;
    //position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    margin: auto;
    width: 100%;
    height: 100%;
    .black-background{
      position: absolute;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      opacity: 0!important;
    }
    .el-image{
      height: 100%;
      overflow: visible!important;
      /deep/.el-image__inner{
        opacity: 0!important;
        background: rgb(88, 96, 105);
      }
    }
  }
  /* 强制预览窗口在红框内 */
  /deep/.el-image-viewer__wrapper {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    transform: none !important;
  }

  /deep/.el-image-viewer__img {
    max-width: 100% !important;
    max-height: 100% !important;
  }
  /deep/.el-image-viewer__close{
    display: none!important;
  }
}
</style>